import Vue from 'vue'
import Vuex from 'vuex'
// import stateStore from './modules/state-store';
import * as types from './actionType/state-type';

Vue.use(Vuex)

const state = {
    indexSlide: false,
    firstTitle:'',
    secondTitle:'',
    touchflg: false,
    searchVuex:''
}

const getters = {
    indexSlide: state => state.indexSlide,
    firstTitle: state => state.firstTitle,
    secondTitle: state => state.secondTitle,
    touchflg: state => state.touchflg,
    searchVuex: state => state.searchVuex
}

const actions = {
    openMenu({ commit, state }) {
        commit(types.INDEX_SLIDE, true)
    },
    closeMenu({commit}){
        commit(types.INDEX_SLIDE, false)
    },
    firstTitle({commit},data) {
        commit(types.FIRST_TITLE, data)
    },
    secondTitle({commit},data) {
        commit(types.SECOND_TITLE, data)
    },
    tstart({ commit, state }) {
        commit(types.TOUCH_START)
    },
    tmove({ commit, state }) {
        commit(types.TOUCH_MOVE)
    },
    tend({ commit, state }) {},
    setSearch({ commit, state }, data) {
        commit("setSearch", data);
      },

}

const mutations = {
    [types.INDEX_SLIDE](state, data){
        state.indexSlide = data
    },
    [types.FIRST_TITLE](state, data){
        state.firstTitle = data
    },
    [types.SECOND_TITLE](state, data){
        state.secondTitle = data
    },
    [types.TOUCH_START](state) {
        state.touchflg = true
    },
    [types.TOUCH_MOVE](state) {
        state.touchflg = false
    },
    setSearch(state, data) {
        state.searchVuex = data;
      },
}

const store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state,
    getters,
    actions,
    mutations,
    modules: {
    //     stateStore,
    }
})

export { store }


// WEBPACK FOOTER //
// ./src/vuex/index.js